<div *ngIf="isLoading" class="overlay">
    <div class="center">
        <div class="spinner-border" role="status"></div>
        <span>Cargando...</span>
    </div>
</div>